import { useAccount } from './requests/use-account';

export function useTreatLastAsDaily(): boolean {
  const { data: accountData } = useAccount();

  return accountData?.account.settings.productSettings?.treatLastAsDaily ?? false;
}
